const modalInitialState = {
	show: false,
};

export default modalInitialState;